"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _uiUtils = require("@airasia/ui-utils");

var _AaDropdown = _interopRequireDefault(require("../airasia-dropdown-component/AaDropdown.component"));

var _AaTextInputComponent = _interopRequireDefault(require("../airasia-textInput-component/AaTextInputComponent"));

var _AaAutoCompleteMobileView = _interopRequireDefault(require("./AaAutoCompleteMobileView.component"));

var _AaAutoComplete = require("./AaAutoComplete.model");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _AaModalContainer = _interopRequireDefault(require("../airasia-modal-component/AaModalContainer"));

var _AaIcon = _interopRequireDefault(require("../airasia-icon-component/AaIcon.component"));

var _LayoutConstants = require("../../Layout/LayoutConstants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AaAutoCompleteComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AaAutoCompleteComponent, _React$Component);

  var _super = _createSuper(AaAutoCompleteComponent);

  function AaAutoCompleteComponent(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AaAutoCompleteComponent);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateMasterState", function (attrName, value) {
      _this.props.controls.textInputControls.controls.updateMasterState(value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onInputFocus", function (bool) {
      _this.setState({
        inputFocus: bool
      });

      if (bool && (_this.props.controls.isMobilePlatform || !_this.props.controls.isMobilePlatform && _this.props.controls.isMobileLayout)) _this.setState({
        fullScreenSelection: bool
      });

      _this.stopScroll(bool);

      _this.props.controls.textInputControls.controls.onInputFocus(bool);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOptionPress", function (item, index) {
      _this.props.controls.dropDownControls.controls.onOptionPress(item, index);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "selectAndCloseMobileView", function (value, item, index) {
      _this.updateMasterState('', value);

      _this.setState({
        isFieldActive: true,
        fullScreenSelection: false
      });

      _this.stopScroll(false);

      _reactNativeWeb.Animated.timing(_this.position, {
        toValue: 1,
        duration: 150
      }).start();

      _this.props.controls.dropDownControls.controls.onOptionPress(item, index);

      _this.props.controls.directFocusEntity(true);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "closeMobileView", function (oldValue, bool) {
      _this.props.controls.textInputControls.controls.updateMasterState(oldValue);

      if (oldValue && oldValue.length > 0) {
        _this.setState({
          isFieldActive: true
        });
      } else {
        _this.setState({
          isFieldActive: false
        });
      }

      _this.setState({
        fullScreenSelection: bool
      });

      _this.stopScroll(bool);

      _this.props.controls.directFocusEntity(true);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stopScroll", function (bool) {
      if (_reactNativeWeb.Platform.OS === 'web' && _this.props.controls.isMobileLayout) {
        if (bool === true) {
          document.body.style.overflowY = 'hidden';
        } else {
          document.body.style.overflowY = 'scroll';
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "openMobileView", function () {
      _this.setState({
        isFieldActive: true,
        fullScreenSelection: true
      });

      _this.stopScroll(true);

      _reactNativeWeb.Animated.timing(_this.position, {
        toValue: 1,
        duration: 150
      }).start();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "returnAnimatedTitleStyles", function () {
      var isFieldActive = _this.state.isFieldActive;
      var outputRangeLow,
          outputRangeHigh = 0;

      if (_this.props.controls.textInputControls.controls.value && _this.props.controls.textInputControls.controls.value.length > 0) {
        outputRangeLow = 16;
        outputRangeHigh = 6;
      } else {
        outputRangeLow = 6;
        outputRangeHigh = 16;
      }

      return {
        top: _this.position.interpolate({
          inputRange: [0, 1],
          outputRange: [outputRangeLow, outputRangeHigh]
        }),
        fontSize: isFieldActive ? _this.titleActiveSize : _this.titleInActiveSize,
        color: isFieldActive ? _this.titleActiveColor : _this.titleInactiveColor,
        fontFamily: _reactNativeWeb.Platform.OS !== 'web' ? _uiUtils.DefaultTokens.FONT_REGULAR : _uiUtils.DefaultTokens.FONT_WEB
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "retainPreviousValueAndCloseModal", function () {
      _this.setState({
        fullScreenSelection: false
      });

      _this.stopScroll(false);
    });
    var _value = _this.props.controls.textInputControls.controls.value;
    _this.position = new _reactNativeWeb.Animated.Value(_value ? 0 : 1);
    _this.titleActiveSize = 12;
    _this.titleInActiveSize = 16;
    _this.titleActiveColor = '#5C5F63';
    _this.titleInactiveColor = '#75767A';
    _this.state = {
      inputFocus: false,
      isFieldActive: false,
      fullScreenSelection: false
    };
    return _this;
  }

  (0, _createClass2["default"])(AaAutoCompleteComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.controls.textInputControls.controls.value !== this.props.controls.textInputControls.controls.value) {
        if (this.props.controls.textInputControls.controls.value && this.props.controls.textInputControls.controls.value.length > 0) {
          this.setState({
            isFieldActive: true
          });

          _reactNativeWeb.Animated.timing(this.position, {
            toValue: 1,
            duration: 150
          }).start();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var DesktopLayout = _reactNativeWeb.Dimensions.get('window').width > _LayoutConstants.LAYOUT.tablet;

      return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
        style: [styles.wrapperContainer, this.state.inputFocus && styles.onFocusContainer, this.state.inputFocus && DesktopLayout && styles.increaseWidth]
      }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
        style: [styles.container]
      }, !this.props.controls.isMobilePlatform && !this.props.controls.isMobileLayout && /*#__PURE__*/_react["default"].createElement(_AaTextInputComponent["default"], {
        controls: _objectSpread(_objectSpread({}, this.props.controls.textInputControls.controls), {}, {
          updateMasterState: this.updateMasterState,
          onInputFocus: this.onInputFocus,
          invalidInput: this.props.controls.invalidInput,
          inputContainerIconName: this.props.controls.inputContainerIconName,
          fullscreenView: this.state.fullScreenSelection
        }),
        translation: _objectSpread({}, this.props.controls.textInputControls.translation)
      }), (this.props.controls.isMobilePlatform || !this.props.controls.isMobilePlatform && this.props.controls.isMobileLayout) && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
        onPress: this.openMobileView
      }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
        style: [styles.mobileContainer, this.props.controls.textInputControls.controls.textInputContainerStyle, !this.props.controls.isMobileLayout && this.props.controls.invalidInput && styles.invalidInputMobileContainer]
      }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Animated.Text, {
        style: [this.returnAnimatedTitleStyles(), styles.titleStyles, !this.state.isFieldActive && this.props.controls.textInputControls.controls.attrName === 'destination' && {
          left: 25
        }, this.props.controls.textInputControls.controls.attrName === 'destination' && {
          paddingLeft: 7
        }]
      }, this.props.controls.textInputControls.translation.title), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
        numberOfLines: 1,
        ellipsizeMode: "tail",
        style: [{
          marginTop: 24,
          marginLeft: 15,
          marginRight: 5
        }, styles.textStyling, this.props.controls.textInputControls.controls.attrName === 'destination' && {
          paddingLeft: 7
        }, this.props.controls.textInputControls.controls.textInputStyles]
      }, this.props.controls.textInputControls.controls.value)), this.props.controls.inputContainerIconName && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
        style: styles.textInputIcon
      }, /*#__PURE__*/_react["default"].createElement(_AaIcon["default"], {
        controls: {
          iconName: this.props.controls.inputContainerIconName,
          iconStyle: {
            height: 24,
            width: 24
          }
        }
      }))))), this.props.controls.isMobilePlatform || !this.props.controls.isMobilePlatform && this.props.controls.isMobileLayout ? this.state.fullScreenSelection ? /*#__PURE__*/_react["default"].createElement(_AaModalContainer["default"], {
        isVisible: this.state.fullScreenSelection,
        wrapperStyle: styles.modal,
        onClose: this.retainPreviousValueAndCloseModal
      }, /*#__PURE__*/_react["default"].createElement(_AaAutoCompleteMobileView["default"], {
        controls: {
          textInputControls: {
            controls: _objectSpread(_objectSpread({}, this.props.controls.textInputControls.controls), {}, {
              updateMasterState: this.updateMasterState
            }),
            translation: _objectSpread({}, this.props.controls.textInputControls.translation)
          },
          closeMobileView: this.closeMobileView,
          dropDownControls: {
            controls: _objectSpread(_objectSpread({}, this.props.controls.dropDownControls.controls), {}, {
              isNewDesign: this.props.controls.isNewDesign,
              isMobileLayout: this.props.controls.isMobileLayout
            }),
            data: this.props.controls.dropDownControls.data
          },
          fullscreenView: this.state.fullScreenSelection
        },
        selectAndCloseMobileView: this.selectAndCloseMobileView
      })) : null : this.state.inputFocus ? /*#__PURE__*/_react["default"].createElement(_AaDropdown["default"], {
        controls: _objectSpread(_objectSpread({}, this.props.controls.dropDownControls.controls), {}, {
          onOptionPress: this.onOptionPress,
          isMobileLayout: this.props.controls.isMobileLayout,
          isNewDesign: this.props.controls.isNewDesign,
          isFocus: this.state.inputFocus
        }),
        data: this.props.controls.dropDownControls.data
      }) : null);
    }
  }]);
  return AaAutoCompleteComponent;
}(_react["default"].Component);

var styles = _StyleSheet["default"].create({
  wrapperContainer: {
    flex: 1
  },
  mobileContainer: {
    borderRadius: 3,
    borderStyle: 'solid',
    borderWidth: 0.5,
    height: 56,
    borderColor: "#c5c9d0"
  },
  invalidInputMobileContainer: {
    borderRadius: 3,
    borderStyle: 'solid',
    borderWidth: 0.5,
    borderColor: "#e10000"
  },
  onFocusContainer: {
    backgroundColor: "#fff",
    zIndex: 2
  },
  modal: {
    flex: 1,
    web: {
      minHeight: 700,
      minWidth: '100%'
    },
    ios: {
      height: '100%'
    },
    android: {
      height: '100%'
    },
    backgroundColor: '#fff'
  },
  titleStyles: {
    position: 'absolute',
    left: 15,
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB,
      fontWeight: '400'
    },
    ios: {
      fontSize: 14
    }
  },
  textStyling: {
    fontFamily: _uiUtils.DefaultTokens.FONT_MEDIUM,
    fontSize: 16,
    color: '#000000',
    paddingTop: 2,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB,
      fontWeight: '500'
    },
    ios: {
      fontSize: 16
    }
  },
  textInputIcon: {
    position: 'absolute',
    right: 0,
    top: 15
  },
  increaseWidth: {
    web: {
      width: '130%',
      boxShadow: '0 0 8px rgba(0,0,0,.3)',
      maxHeight: 56
    }
  }
});

var _default = AaAutoCompleteComponent;
exports["default"] = _default;